<template>
    <div class="col-md-12 p-3 h-150 newscard" v-if="this.headline.length>0">
        <div class="p-5rounded-3">
            <h2><div class="heading"> {{headline}}</div></h2>
            <div class="postedon"> {{formateDate(posted)}}</div>
            <p>{{truncate(body,20)}}...</p>
            <a class="review" :href="getNewArticleURL(newsid,brand)" :aria-label="'Read ' + headline + ' article'">{{this.ReadMore}}</a>
        </div>
    </div>
    <div v-else class="heading">
        {{this.NoArticle}}
    </div>
</template>
<script>
    import {readMore,noArticle} from '../../constants/labels.config'
    export default {
        name: "NewsCard",
        props: ["newsid","headline", "body", "posted","brand"],
        data(){
            return{
                NoArticle:noArticle,
                ReadMore:readMore,
            }
        },
        methods:{
            formateDate(date)
            {
                const event = new Date(date);
                const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
                return event.toLocaleDateString(undefined, options);
            },
            getNewArticleURL(id, brand)
            {
                return "NewsEvents/NewsArticle/?newsid=" + id + "&brand=" + brand;
            },
            truncate(data, no_words) {
                return data.split(" ").splice(0,no_words).join(" ");
            }
        }
    }
</script>